import Image from 'next/image'

interface PersonInfoProps extends React.HTMLAttributes<HTMLDivElement> {
  name: string
  title: string
  image?: string
  className?: string
}

const PersonInfo = ({
  name,
  className,
  title,
  image,
  ...props
}: PersonInfoProps): JSX.Element => (
  <div className={`flex items-center space-x-4 ${className || ''}`} {...props}>
    {image && (
      <div className='relative flex-shrink-0 h-8 w-8 sm:h-10 sm:w-10 lg:h-12 lg:w-12'>
        <Image
          className='rounded-full'
          alt={`${name}'s avatar`}
          src={image}
          fill
          style={{ objectFit: 'cover' }}
        />
      </div>
    )}

    <div className='small-body-text'>
      <p className='font-demibold line-clamp-1'>{name}</p>
      <p className='font-demibold text-neutral-60 line-clamp-1'>{title}</p>
    </div>
  </div>
)

export default PersonInfo
